// Start Đổi font chữ từng swatch + text box Đổi font theo
let interval = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container__v2');
  let apValueCheckboxs = $('.apo-f_swatches1 input:checked').val();
  let fontValue = null
  if (apElements){
    let elmentCheckboxs = $('.apo-f-swatches .avp-productoptioncheckwrapper')
    for(let i = 0; i < elmentCheckboxs.length; i++) {
      let valueInputs = $($('.apo-f-swatches .avp-productoptioncheckwrapper input')[i]).val()
      $(elmentCheckboxs[i]).css("font-family", valueInputs)
    }
    if (apValueCheckboxs) {
      fontValue = apValueCheckboxs
      $('.apo-f_text1 input').css('font-family', fontValue)
    }
  }
}, 100);

let interval1 = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container__v2');
  let apValueCheckboxs = $('.apo-f_swatches2 input:checked').val();
  let fontValue = null
  if (apElements){
    let elmentCheckboxs = $('.apo-f-swatches .avp-productoptioncheckwrapper')
    for(let i = 0; i < elmentCheckboxs.length; i++) {
      let valueInputs = $($('.apo-f-swatches .avp-productoptioncheckwrapper input')[i]).val()
      $(elmentCheckboxs[i]).css("font-family", valueInputs)
    }
    if (apValueCheckboxs) {
      fontValue = apValueCheckboxs
      $('.apo-f_text2 input').css('font-family', fontValue)
    }
  }
}, 100);

let interval2 = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container__v2');
  let apValueCheckboxs = $('.apo-f_swatches3 input:checked').val();
  let fontValue = null
  if (apElements){
    let elmentCheckboxs = $('.apo-f-swatches .avp-productoptioncheckwrapper')
    for(let i = 0; i < elmentCheckboxs.length; i++) {
      let valueInputs = $($('.apo-f-swatches .avp-productoptioncheckwrapper input')[i]).val()
      $(elmentCheckboxs[i]).css("font-family", valueInputs)
    }
    if (apValueCheckboxs) {
      fontValue = apValueCheckboxs
      $('.apo-f_text3 input').css('font-family', fontValue)
    }
  }
}, 100);

let interva4 = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container__v2');
  let apValueCheckboxs = $('.apo-f_swatches4 input:checked').val();
  let fontValue = null
  if (apElements){
    let elmentCheckboxs = $('.apo-f-swatches .avp-productoptioncheckwrapper')
    for(let i = 0; i < elmentCheckboxs.length; i++) {
      let valueInputs = $($('.apo-f-swatches .avp-productoptioncheckwrapper input')[i]).val()
      $(elmentCheckboxs[i]).css("font-family", valueInputs)
    }
    if (apValueCheckboxs) {
      fontValue = apValueCheckboxs
      $('.apo-f_text4 input').css('font-family', fontValue)
    }
  }
}, 100);
// End Đổi font chữ từng swatch